var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLuge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 33.4,
    cy: 20.6,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7,72h25.5L38.3,36.1c-1.6-1.6-3.9-2.6-6.4-2.6c-5,0-9,4-9,9c0,2.5,1,4.7,2.6,6.4L48.7,72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.7,122c2,2,5.3,2,7.3,0s2-5.3,0-7.3L79.4,77.2H64.8L109.7,122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6,124.3c-4.3,4.3-10,6.7-16.1,6.7c-6.1,0-11.8-2.4-16.1-6.7L16.3,46.2l-1.9,1.9l78.1,78.1c4.8,4.8,11.2,7.5,18.1,7.5 c6.8,0,13.2-2.6,18.1-7.5L126.6,124.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuge);
export default __webpack_public_path__ + "static/media/luge.a07144d082b8835248aeb2c44c1990ae.svg";
export { ForwardRef as ReactComponent };